import { render, staticRenderFns } from "./employeeTag.vue?vue&type=template&id=05448f1e&scoped=true&"
import script from "./employeeTag.vue?vue&type=script&lang=js&"
export * from "./employeeTag.vue?vue&type=script&lang=js&"
import style0 from "./employeeTag.vue?vue&type=style&index=0&id=05448f1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05448f1e",
  null
  
)

export default component.exports